<template>
  <div id="promotion">
    <img :src="imgSrc" alt="">
    <el-pagination :page-size='pageSize' @current-change='changepage' style="position:absolute;bottom:20px;left:0;right:0;margin:auto;z-index:99" background layout="prev, pager, next" :total="3"></el-pagination>
  </div>

</template>

<script>
export default {
  data(){
    return{
      imgSrc:require('../assets/promotionList/大赛成绩名单1.jpg'),
      pageSize:1,
      imgSrcList:[{
        src:require('../assets/promotionList/大赛成绩名单1.jpg'),
      },{
        src:require('../assets/promotionList/大赛成绩名单2.jpg'),
      }
	  ,{
        src:require('../assets/promotionList/大赛成绩名单3.jpg'),
      },
	  ]
    }
  },

  methods:{
    changepage(res){
      console.log(res)
      this.imgSrc = this.imgSrcList[res-1].src
      document.body.scrollTop = document.documentElement.scrollTop = 800
    }
  }
}
</script>

<style lang="scss">
  #promotion{
    text-align: center;
    position: relative;
    // position: absolute
    img{
      width: 100%;
      display:list-item;
    }
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fec08b;
  }
</style>



// WEBPACK FOOTER //
// src/components/promotion.vue